var Notifications = {
    count: 0,

    init: function () {
        document.addEventListener('click', function (event) {
            if (event.target.matches('.notification')) {
                event.preventDefault();

                Notifications.hide(event.target.dataset.iterator);
            }
        });
    },

    add: function(message, type) {
        Notifications.count = Notifications.count + 1;

        if (type === undefined) {
            type = 'success';
        }

        var i = Notifications.count;
        var notifyDiv = document.createElement('div');
        notifyDiv.setAttribute('class', 'hidden notification notification--' + type);
        notifyDiv.setAttribute('id', 'notification_' + i);
        notifyDiv.setAttribute('data-iterator', i);
        notifyDiv.innerHTML = message;

        document.getElementById('notification_container').appendChild(notifyDiv);
        document.getElementById('notification_' + i).classList.remove('hidden');

        setTimeout(function() {
            Notifications.hide(i);
        }, 4500);
    },

    success: function(message) {
        Notifications.add(message, 'success');
    },

    warn: function(message) {
        Notifications.add(message, 'warning');
    },

    error: function(message) {
        Notifications.add(message, 'error');
    },

    hide: function(i) {
        let element = document.getElementById('notification_' + i);
        if (element) {
            element.classList.add('hidden');

            setTimeout(function() {
                Notifications.remove(i);
            }, 250);
        }
    },

    remove: function(i) {
        document.getElementById('notification_' + i).remove();
    },
};

Notifications.init();
window.Notifications = Notifications;